export interface LegacySystemPaymentCard {
  id: number
  connected: string
  company: string
  number: string
  expiry: string
  type: string
  registeredAt: string
  buyer: string
  email: string
  phone: string
}

export const legacySystemPaymentCardGroups = ['Mock 그룹 01', 'Mock 그룹 02']

export const legacySystemPaymentCardFixture: LegacySystemPaymentCard = {
  id: 1,
  connected: '월사용료, 스토리지',
  company: 'Mock 카드사',
  number: '0000-****-****-0000',
  expiry: '12/30',
  type: '개인',
  registeredAt: '2026-08-20',
  buyer: 'Mock 구매자',
  email: 'mock@example.invalid',
  phone: '000-0000-0000',
}
